import C from "@/utils/constants";
import type { CellBoundingBox } from "@/types/api";

export const isMarkedCell = (cell: CellBoundingBox): boolean =>
  cell.tag === C.CELL_TAGS.SELECTED || cell.tag === C.CELL_TAGS.UNCLASSIFIED;

export const clearCellTag = (cell: CellBoundingBox): CellBoundingBox => 
  ({ ...cell, tag: "" } as CellBoundingBox);

export const moveCellsBetweenArrays = (
  cellsToMove: CellBoundingBox[],
  sourceCellArray: CellBoundingBox[],
  targetCellArray: CellBoundingBox[]
): { nextSourceCellArray: CellBoundingBox[]; nextTargetCellArray: CellBoundingBox[] } => {
  if (!cellsToMove.length) {
    return { nextSourceCellArray: sourceCellArray, nextTargetCellArray: targetCellArray };
  }

  const tileIdsToMove = new Set(cellsToMove.map((cell) => cell.tile_id));
  const clearedCells = cellsToMove.map(clearCellTag);

  const nextSourceCellArray = sourceCellArray.filter((cell) => !tileIdsToMove.has(cell.tile_id));
  const nextTargetCellArray = targetCellArray.filter((cell) => !tileIdsToMove.has(cell.tile_id)).concat(clearedCells);

  return { nextSourceCellArray, nextTargetCellArray };
};
